import React from "react";
import styles from "./notif-dot.module.scss";

const NotifDot = ({ height, width }) => {
  return <div className={styles.notifMarker} style={{ height, width }}></div>;
};

export default NotifDot;
